module.exports = __webpack_public_path__ + "static/img/jldx.bcf20a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/jldx.jpg
// module id = vpRi
// module chunks = 1